module.exports = __webpack_public_path__ + "img/it.d780c913.png";